import React, { useEffect, useState } from "react";
import {
  Color,
  FontStyle,
  Slug,
  SurveyButtonStyle,
  navPaddingTop,
} from "../constants";
import { Avatar, Box, Button, CircularProgress, Stack } from "@mui/material";
import { setReferralCode } from "../service/CookieService";
import * as apiService from "../service/ApiService";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { JobBg } from "../components/JobPanels/jobLayoutElements";
import LogoBubble from "../components/LogoBubble";

const styles = {
  outer: {
    paddingTop: navPaddingTop,
    ...FontStyle.body,
  },
  li: {
    marginBottom: "14px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "18px",
  },
};

const CircleNumber = ({ number }) => {
  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{
        width: "30px",
        minWidth: "30px",
        height: "30px",
        borderRadius: "50%",
        backgroundColor: Color.primary,
      }}>
      {number}
    </Stack>
  );
};

const GigSplash = ({ to, refToken, refData }) => {
  return (
    <Box
      sx={{
        ...styles.outer,
        // position: "relative",
        width: "100%",
        // top: navPaddingTop,
        // // height: "100%",
        // // height: "100vh",
        // minHeight: "calc(100vh - 100px)",
      }}>
      <JobBg />
      <Stack
        direction="column"
        spacing={2}
        alignItems="center"
        sx={{
          padding: { xs: "20px", sm: "36px" },
          // border: "1px solid black",
          backgroundColor: "white",
          // height: "100%",
          height: "fit-content",
          borderRadius: "10px",
          maxWidth: { xs: "calc(100% - 64px)", sm: "550px" },
          width: "100%",
          // margin: "auto",
          position: "absolute",
          top: "calc(50%)",
          left: "50%",
          transform: "translate(-50%, -50%)",
          boxShadow: "0px 3px 10px 0px rgba(0,0,0,0.25)",
        }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          spacing={2}
          sx={{ width: "100%" }}>
          {refData.profilePic && (
            <Avatar
              src={refData.profilePic}
              sx={{ width: "128px", height: "128px" }}
            />
          )}
          <LogoBubble size="128px" />
        </Stack>
        {refData.firstName && (
          <Box
            sx={{
              ...FontStyle.headingBody,
              fontSize: "24px",
            }}>
            {refData.firstName} has invited you to join Fetti!
          </Box>
        )}
        <Box
          sx={{
            paddingTop: "8px",
            fontSize: "20px",
            textAlign: "center",
          }}>
          <i>
            <b>Looking for work?</b> Fill out this 2 minute survey to get
            matched with hundreds of jobs instantly
          </i>
          !
        </Box>
        <Box>
          <ol
            style={{
              fontSize: "16px",
              lineHeight: "1.5em",
              paddingLeft: "20px",
              // remove number
              listStyleType: "none",
            }}>
            <li style={styles.li}>
              {" "}
              <CircleNumber number={1} />
              Fill out this 2 minute survey
            </li>
            <li style={styles.li}>
              <CircleNumber number={2} />
              Fetti will instantly match your job preferences with hundreds of
              eligible jobs
            </li>
            <li style={styles.li}>
              <CircleNumber number={3} />
              Apply to jobs with one click!
            </li>
          </ol>
        </Box>
        <a href={to} style={{ width: "100%" }}>
          <Button
            sx={{
              ...SurveyButtonStyle.defaultStyling,
              ...SurveyButtonStyle.primaryColorScale,
            }}
            disableRipple
            fullWidth>
            LET'S GO
          </Button>
        </a>
      </Stack>
    </Box>
  );
};

const ReferralSignupRedirect = () => {
  const dispatch = useDispatch();
  const queryParameters = new URLSearchParams(window.location.search);
  const refToken = queryParameters.get("ref_id");
  const [destination, setDestination] = useState(null);
  const [refData, setRefData] = useState({
    firstName: null,
    profilePic: null,
    scale: 1,
  });
  useEffect(() => {
    if (refToken) {
      const { isNewRef, referralCode } = setReferralCode(refToken);
      apiService.logAffiliateLanded(
        dispatch,
        {
          token: referralCode,
          isNewRef,
        },
        {
          handleSuccess: ({ first_name, profile_pic, scale }) => {
            console.log("success", first_name, profile_pic, scale);
            setRefData({
              firstName: first_name,
              profilePic: profile_pic,
              scale: scale,
            });
          },
        }
      );
      if (refToken.startsWith("g")) {
        setDestination(Slug.surveyGigInitial);
      } else if (refToken.startsWith("j")) {
        setDestination(Slug.surveyInitial);
      } else {
        setDestination("error");
      }
    } else {
      setDestination("error");
    }
  }, [refToken]);

  if (destination === "error") {
    return (
      <Box sx={styles.outer}>
        Invalid Link. <a href={Slug.surveyGigInitial}>Click here</a> to sign up
        for Fetti and elevate your job search now!
      </Box>
    );
  }
  if (destination === Slug.surveyGigInitial) {
    return <GigSplash to={destination} refToken={refToken} refData={refData} />;
  }
  if (destination === Slug.surveyInitial) {
    return <GigSplash to={destination} refToken={refToken} refData={refData} />;
  }
  // if (destination) {
  //   return <Navigate to={destination} />;
  // }
  return (
    <Box sx={styles.outer}>
      <CircularProgress />
    </Box>
  );
};

export default ReferralSignupRedirect;
